import React from 'react'
import { Icon } from './Icon'
import { IMG } from './images'

const PANELS = [
  {
    img: 'bess',
    label: 'High-Performance Batteries',
    title: 'High-Performance Batteries',
    desc: 'Advanced LFP, NMC and LTO battery packs engineered for reliability, safety and maximum cycle life.',
  },
  {
    img: 'solar',
    label: 'Renewable Energy',
    title: 'Renewable Energy',
    desc: 'Complete solar EPC and Solar + BESS integration for commercial, industrial and utility-scale projects.',
  },
  {
    img: 'automation',
    label: 'Smart & Connected',
    title: 'Smart & Connected',
    desc: 'Industry 4.0 automation — vision systems, PLC/HMI and connected controls.',
  },
  {
    img: 'robotics',
    label: 'Quick Installation',
    title: 'Quick Installation',
    desc: 'Factory-tested systems designed for rapid on-site commissioning with minimal downtime.',
  },
  {
    img: 'npd',
    label: 'Lifetime Support',
    title: 'Lifetime Support',
    desc: 'Dedicated service teams providing monitoring, maintenance and technical support throughout the product lifecycle.',
  },
  {
    img: 'mobility',
    label: 'Energy Storage',
    title: 'Energy Storage',
    desc: 'Scalable BESS platforms for grid stabilisation, peak shaving and behind-the-meter energy management.',
  },
]

const ACTIVE_W = 52
const INACTIVE_W = (100 - ACTIVE_W) / (PANELS.length - 1)

export function FeaturePanels({ onNavigate }) {
  const [active, setActive] = React.useState(2)

  return (
    <div style={{ width: '100%', marginBottom: 'var(--section-y)' }}>
      <div className="adr-panels" style={{
        display: 'flex',
        height: 480,
        overflow: 'hidden',
      }}>
        {PANELS.map((p, i) => {
          const isActive = i === active
          const w = isActive ? ACTIVE_W : INACTIVE_W

          return (
            <div
              key={p.label}
              className="adr-panel"
              onMouseEnter={() => setActive(i)}
              style={{
                position: 'relative',
                width: `${w}%`,
                flexShrink: 0,
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'width 420ms cubic-bezier(0.4,0,0.2,1)',
                willChange: 'width',
              }}
            >
              {/* background image */}
              <div style={{
                position: 'absolute',
                inset: '-5%',
                backgroundImage: `url(${IMG(p.img)})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                transform: isActive ? 'scale(1.05)' : 'scale(1)',
                transition: 'transform 600ms cubic-bezier(0.4,0,0.2,1)',
                willChange: 'transform',
              }} />

              {/* overlay */}
              <div style={{
                position: 'absolute', inset: 0,
                background: isActive
                  ? 'linear-gradient(135deg,rgba(5,15,31,0.80) 0%,rgba(5,15,31,0.45) 100%)'
                  : 'rgba(5,15,31,0.70)',
                transition: 'background 400ms ease',
              }} />

              {/* collapsed label */}
              <div style={{
                position: 'absolute', inset: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                opacity: isActive ? 0 : 1,
                transition: 'opacity 200ms ease',
                pointerEvents: 'none',
              }}>
                <span style={{
                  writingMode: 'vertical-rl',
                  transform: 'rotate(180deg)',
                  fontFamily: 'var(--font-ui)', fontWeight: 700, fontSize: 16,
                  color: 'rgba(255,255,255,0.95)', letterSpacing: '0.06em',
                  whiteSpace: 'nowrap',
                }}>{p.label}</span>
              </div>

              {/* expanded content */}
              <div style={{
                position: 'absolute', inset: 0,
                padding: '40px 36px',
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
                opacity: isActive ? 1 : 0,
                transform: isActive ? 'translateY(0)' : 'translateY(12px)',
                transition: 'opacity 300ms ease 140ms, transform 300ms ease 140ms',
                pointerEvents: isActive ? 'auto' : 'none',
              }}>
                <button
                  onClick={() => onNavigate && onNavigate('Services')}
                  style={{
                    alignSelf: 'flex-start', marginBottom: 20,
                    width: 44, height: 44, borderRadius: '50%',
                    border: 'none', cursor: 'pointer',
                    background: 'var(--energy)', color: 'var(--blue-900)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: 'var(--glow-green)',
                    transition: 'transform 200ms ease',
                  }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                >
                  <Icon name="arrow-up-right" style={{ width: 20, height: 20 }} />
                </button>
                <h3 style={{
                  fontFamily: 'var(--font-display)', fontWeight: 800,
                  fontSize: 'clamp(1.4rem,1rem + 1.5vw,2rem)',
                  color: '#fff', margin: '0 0 12px', lineHeight: 1.1,
                }}>{p.title}</h3>
                <p style={{
                  margin: 0, fontSize: 15, lineHeight: 1.55,
                  color: 'rgba(255,255,255,0.78)', maxWidth: 380,
                }}>{p.desc}</p>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
